import { createGlobalStyle } from "styled-components"

const Typography = createGlobalStyle`

`

export default Typography
